/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: tduzggWPyptPHtemkm2DXC

import * as React from "react";
import { getActiveVariation } from "@plasmicapp/react-web/lib/splits";
import { ThemeOrangeContextProvider } from "./PlasmicGlobalVariant__ThemeOrange"; // plasmic-import: 21mZbQtB3lIk/globalVariant
import { ThemePurpleDarkContextProvider } from "./PlasmicGlobalVariant__ThemePurpleDark"; // plasmic-import: PwTMlLBt_8qs/globalVariant

type GetActiveVariationParams = Partial<
  Parameters<typeof getActiveVariation>[0]
>;

export interface PlasmicSplitsProviderProps extends GetActiveVariationParams {
  children?: React.ReactNode;
}

export const splits = [
  {
    id: "IKoS-23uxIuK",
    name: "Theme: Orange",
    projectId: "tduzggWPyptPHtemkm2DXC",
    externalId: null,
    description: "",
    pagesPaths: [
      "/",
      "/apply",
      "/request-rejected",
      "/request-failed",
      "/gdpr",
      "/terms",
      "/remarketing"
    ],

    type: "segment",
    slices: [
      { id: "FMahYtA7Et3-", externalId: null, cond: {}, contents: [] },
      {
        id: "FfcK1KO7_S9N",
        externalId: null,
        cond: {
          or: [
            { "==": [{ var: "domain" }, "nebank-test-orange.localhost"] },
            { "==": [{ var: "domain" }, "design2.nebank.landing.nlms.cz"] },
            { "==": [{ var: "domain" }, "we.nebankovnipujcka.cz"] }
          ]
        },
        contents: [
          {
            type: "global-variant",
            projectId: "tduzggWPyptPHtemkm2DXC",
            groupId: "21mZbQtB3lIk",
            group: "ThemeOrange",
            variant: "override"
          }
        ]
      }
    ]
  },
  {
    id: "GWpn36zoNnhn",
    name: "Theme Purple: Dark",
    projectId: "tduzggWPyptPHtemkm2DXC",
    externalId: null,
    description: null,
    pagesPaths: [
      "/",
      "/apply",
      "/request-rejected",
      "/request-failed",
      "/gdpr",
      "/terms",
      "/remarketing"
    ],

    type: "segment",
    slices: [
      { id: "B2N57deZx52Z", externalId: null, cond: {}, contents: [] },
      {
        id: "4RK6s4R300YA",
        externalId: null,
        cond: {
          and: [
            { "==": [{ var: "isDarkMode" }, true] },
            {
              or: [
                { "==": [{ var: "domain" }, "localhost"] },
                { "==": [{ var: "domain" }, "design.nebank.landing.nlms.cz"] },
                { "==": [{ var: "domain" }, "nebankovnipujcka.cz"] }
              ]
            }
          ]
        },
        contents: [
          {
            type: "global-variant",
            projectId: "tduzggWPyptPHtemkm2DXC",
            groupId: "PwTMlLBt_8qs",
            group: "ThemePurpleDark",
            variant: "override"
          }
        ]
      }
    ]
  }
];

export function getGlobalContextValueFromVariation(
  groupId: string,
  variation: Record<string, string>
) {
  let groupValue: string | undefined = undefined;
  Object.keys(variation).forEach((variationKey: string) => {
    const [_type, splitId] = variationKey.split(".");
    const sliceId = variation[variationKey];
    const split = splits.find(
      s => s.id === splitId || s.externalId === splitId
    );
    if (split) {
      const slice = split.slices.find(
        s => s.id === sliceId || s.externalId === sliceId
      );
      if (slice) {
        const content = slice.contents.find(c => c.groupId === groupId);
        if (content) {
          groupValue = content.variant;
        }
      }
    }
  });
  return groupValue;
}

export default function PlasmicSplitsProvider(
  props: PlasmicSplitsProviderProps
) {
  const { children, traits, ...rest } = props;
  const variation = getActiveVariation({
    splits,
    traits: traits ?? {},
    ...rest
  });

  return (
    <>
      <ThemePurpleDarkContextProvider
        value={getGlobalContextValueFromVariation("PwTMlLBt_8qs", variation)}
      >
        <ThemeOrangeContextProvider
          value={getGlobalContextValueFromVariation("21mZbQtB3lIk", variation)}
        >
          {children}
        </ThemeOrangeContextProvider>
      </ThemePurpleDarkContextProvider>
    </>
  );
}
